import React from 'react';

const backDropStyles = {
  height: '100%',
  left: 0,
  zIndex: 1000,
  position: 'fixed',
};

function Loading() {
  return (
    <div className="hd-coverup fade-in">
      <div style={backDropStyles} className="pre-loader">
        <div
          data-automation-id="thd-loading-indicator"
          className="segment-spinner"
        />
      </div>
    </div>
  );
}

export default Loading;
